import { render, staticRenderFns } from "./BoxGroupSelectInput.vue?vue&type=template&id=4d544a23&scoped=true&"
import script from "./BoxGroupSelectInput.vue?vue&type=script&lang=js&"
export * from "./BoxGroupSelectInput.vue?vue&type=script&lang=js&"
import style0 from "./BoxGroupSelectInput.vue?vue&type=style&index=0&id=4d544a23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d544a23",
  null
  
)

export default component.exports